module.exports = __webpack_public_path__ + "static/media/tax-icon.20e04cd2.svg";